import { QueryClient } from '@tanstack/react-query';

import { queryClientConfig } from '@/shared/configs';

export const queryClient = new QueryClient(queryClientConfig);
